import React from 'react'
import { colors, space } from '@entur/tokens'
import { Badge } from '@entur/layout'
import { Tooltip } from '@entur/tooltip'

type DraftValueProps = {
  currentValue: string
  draftValue?: string
  hideToolTip?: boolean
}

export const DraftValue: React.FC<DraftValueProps> = (props) => {
  const content = (
    <div style={{ cursor: 'default', display: 'inline-block' }}>
      <span style={{ borderBottom: `2px dotted ${colors.validation.mintContrast}` }}>{props.draftValue}</span>
      <Badge variant="success" style={{ display: 'inline', marginLeft: space.extraSmall2 }}>
        NY
      </Badge>
    </div>
  )

  if (props.draftValue && props.currentValue !== props.draftValue) {
    return props.hideToolTip ? (
      content
    ) : (
      <Tooltip content={`Nåværende verdi: ${props.currentValue}`} placement="top">
        {content}
      </Tooltip>
    )
  }
  return <>{props.currentValue}</>
}
